import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  sendContact({ commit }, { name, email, phone, message, title, lineId, options, g_recaptcha_response }) {
    return request.post(`/contact/post`, {
      name,
      email,
      phone,
      message,
      title,
      lineId,
      options,
      g_recaptcha_response,
    })
  },
}
